import { render, staticRenderFns } from "./EmptyCard.vue?vue&type=template&id=a0c86210"
import script from "./EmptyCard.vue?vue&type=script&lang=js"
export * from "./EmptyCard.vue?vue&type=script&lang=js"
import style0 from "./EmptyCard.vue?vue&type=style&index=0&id=a0c86210&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports